function lawyerMemberCarousel() {
    document.querySelectorAll('.feature-slide__splide').forEach(carousel => new Splide(carousel, {
        perPage: 2,
        pagination: false,
        type: 'loop',
        autoWidth: true,
        autoplay: true,
        interval: 3000, 
        padding: {
            left: 0,
            right: '5rem'
        },
        breakpoints: {
            992: {
                perPage: 1,
                autoWidth: 'false'
            },
        }
    }).mount());
}